import React, { useEffect, useState } from "react";
import {
  ADMIN,
  authHeader,
  MASTER_SALON,
  MASTER_SALON_USER,
  productSteps,
  SALON_BY_ID,
  UPDATE_ORDER_STATUS,
} from "../../../utils/Constants";
import { toast } from "react-toastify";
import axios from "axios";
import useAuthContext from "../../../hooks/useAuthContext";
import { getAddedOnDateTime } from "../../../Functions/dateTime";
import DynamicDropdown from "./DynamicDropdown";
import StarRatings from "react-star-ratings";
import useLoading from "../../../hooks/useLoading";
import Loader from "../../Loader";
import RenderMap from "../../Map/index";
import productImage from "../../../uploads/product/product1.jpg";
import PaymentModeSelection from "./PaymentModeSelection";

const setValue = (status) => {
  switch (status) {
    case "1":
      return "confirmed";
    case "2":
      return "shipped";
    case "3":
      return "delivered";
    case "4":
      return "cancelled";
    default:
      return "pending";
  }
};

const Summary = ({ orderDetails, apiCall }) => {
  const [commonData, setCommonData] = useState({
    check: "",
    modal: false,
    data: undefined,
  });

  const [orderStatus, setOrderStatus] = useState({
    status: setValue(orderDetails?.productOrders?.productsProcessingStatus),
    number: orderDetails?.productOrders?.productsProcessingStatus,
  });

  console.log("orderStatus", orderStatus);

  useEffect(() => {
    if (
      orderStatus.number === 3 &&
      orderDetails?.productOrders?.paymentMode === "COD"
    ) {
      setCommonData({
        check: "paymentMode",
        modal: true,
        data: {
          _id: orderDetails?._id,
          statusNumber: orderStatus.number,
          actualStatus: orderDetails?.productOrders?.productsProcessingStatus,
        },
      });
      document.body.style.overflow = "hidden";
    }
  }, [orderStatus]);

  const { role, salonDetails, token } = useAuthContext();
  const [loader, showLoader, hideLoader] = useLoading();

  const changedStatus = async (e) => {
    e.preventDefault();
    if (
      //USE THIS WHEN YOU WANT STATUS IS CHANGED STEP BY STEP
      // orderStatus.number - 1 ===
      //   Number(orderDetails?.productOrders?.productsProcessingStatus) ||
      // orderStatus.number === 4

      //USE THIS WHEN YOU WANT STATUS IS NOT CHANGED STEP BY STEP
      orderStatus?.number >
      Number(orderDetails?.productOrders?.productsProcessingStatus)
    ) {
      if (token) {
        try {
          showLoader();
          const res = await axios.put(
            `${UPDATE_ORDER_STATUS}${orderDetails?._id}/product`,
            {
              productsProcessingStatus: orderStatus.number.toString(),
            },
            {
              //headers: authHeader,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
                "X-Requested-With": "XMLHttpRequest",
              },
            }
          );
          if (res.status === 200) {
            apiCall();
            hideLoader();
            updateSalon();
            toast.success("Status Changed", {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          } else {
            console.log("else error: ", res.status);
          }
        } catch (error) {
          console.log("catch error: ", error);
          if (error?.response?.status === 502) {
            hideLoader();
            toast.error(error?.response?.data?.message, {
              position: "bottom-center",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            });
          }
        }
      }
    } else {
      //USE THIS WHEN YOU WANT STATUS IS CHANGED STEP BY STEP

      // toast.warn("Changed Status Step By Step", {
      //   position: "bottom-center",
      //   autoClose: 1000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      // });

      //USE THIS WHEN YOU WANT STATUS IS NOT CHANGED STEP BY STEP
      toast.warn("You can't go backward", {
        position: "bottom-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };

  const updateSalon = async () => {
    if (token) {
      try {
        showLoader();
        const res = await axios.get(`${SALON_BY_ID}${salonDetails?._id}`, {
          //headers: authHeader,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (res.status === 200) {
          window.localStorage.setItem(
            "salon_details",
            JSON.stringify(res?.data?.salon)
          );
          hideLoader();
        } else {
          console.log("error", res.status);
        }
      } catch (error) {
        console.log("catch error: ", error);
        if (error.response.status === 502) {
          hideLoader();
          toast.error(error.response.data.message, {
            position: "bottom-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        }
      }
    }
  };

  const walletBreak = (w) => {
    let wallet = w;
    if (orderDetails?.serviceOrders) {
      wallet = wallet / 2;
      return wallet?.toFixed(2);
    } else {
      return wallet?.toFixed(2);
    }
  };

  return (
    <>
      <div className="container ms-0 ps-0">
        <div className="row gap-lg-0 gap-4">
          {/* order status */}
          <div className="col-lg-6 col-12">
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">{`${
                  (role === ADMIN ||
                    role === MASTER_SALON ||
                    role === MASTER_SALON_USER) &&
                  salonDetails
                    ? "Update order status"
                    : "Order Status"
                }`}</h3>
              </div>
              <div className="cardContent">
                {(role === ADMIN ||
                  role === MASTER_SALON ||
                  role === MASTER_SALON_USER) &&
                salonDetails ? (
                  <>
                    <div className="w-100">
                      <DynamicDropdown
                        data={productSteps.slice(1)}
                        htmlFor="Order Status"
                        type="text"
                        name="orderStatus"
                        placeholder="Select Order Status"
                        stateData={orderStatus.status}
                        setStateData={(e, x) => {
                          setOrderStatus({
                            status: e,
                            number: x,
                          });
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn OtpBtn shadow-none mt-2"
                      style={{ width: "30%" }}
                      onClick={changedStatus}
                      disabled={
                        parseInt(
                          orderDetails?.productOrders?.productsProcessingStatus
                        ) >= 3 && true
                      }
                    >
                      {loader ? (
                        <div className="d-flex justify-content-center">
                          <Loader height="25" width="25" color="#fff" />
                        </div>
                      ) : (
                        "Change"
                      )}
                    </button>
                  </>
                ) : (
                  <div className="d-flex justify-content-between">
                    <span
                      className="font14x500"
                      style={{ color: "var(--text4)" }}
                    >
                      Status
                    </span>
                    <span className="font14x500 text-capitalize">
                      {setValue(
                        orderDetails?.productOrders?.productsProcessingStatus
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* status summary */}
          <div className="col-lg-6 col-12">
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">Status Summary</h3>
              </div>
              <div className="cardContent">
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Confirmed
                  </span>
                  {orderDetails?.length !== 0 && (
                    <span className="font14x500">
                      {orderDetails?.productOrders
                        ?.productsStatusTimestamps[1] &&
                      orderDetails?.productOrders
                        ?.productsStatusTimestamps[1] !== null
                        ? getAddedOnDateTime(
                            orderDetails?.productOrders
                              ?.productsStatusTimestamps[1]
                          )
                        : "--"}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Shipped
                  </span>
                  {orderDetails?.length !== 0 && (
                    <span className="font14x500">
                      {orderDetails?.productOrders
                        ?.productsStatusTimestamps[2] &&
                      orderDetails?.productOrders
                        ?.productsStatusTimestamps[2] !== null
                        ? getAddedOnDateTime(
                            orderDetails?.productOrders
                              ?.productsStatusTimestamps[2]
                          )
                        : "--"}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Delivered
                  </span>
                  {orderDetails?.length !== 0 && (
                    <span className="font14x500">
                      {orderDetails?.productOrders
                        ?.productsStatusTimestamps[3] &&
                      orderDetails?.productOrders
                        ?.productsStatusTimestamps[3] !== null
                        ? getAddedOnDateTime(
                            orderDetails?.productOrders
                              ?.productsStatusTimestamps[3]
                          )
                        : "--"}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Cancelled
                  </span>
                  {orderDetails?.length !== 0 && (
                    <span className="font14x500">
                      {orderDetails?.productOrders
                        ?.productsStatusTimestamps[4] &&
                      orderDetails?.productOrders
                        ?.productsStatusTimestamps[4] !== null
                        ? getAddedOnDateTime(
                            orderDetails?.productOrders
                              ?.productsStatusTimestamps[4]
                          )
                        : "--"}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* customer details */}
          <div className="col-lg-7 col-12 g-lg-4">
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">Customer Details</h3>
              </div>
              <div className="cardContent">
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Customer Name
                  </span>
                  <span className="font14x500 text-capitalize">
                    {orderDetails?.user?.name}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Email Id
                  </span>
                  <span className="font14x500">
                    {orderDetails?.user?.email !== ""
                      ? orderDetails?.user?.email
                      : "--"}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Phone Number
                  </span>
                  <span className="font14x500">
                    {orderDetails?.user?.mobile}
                  </span>
                </div>

                <div className="">
                  <hr />
                  <div className="d-flex justify-content-between">
                    <span
                      className="font14x500"
                      style={{ color: "var(--text4)" }}
                    >
                      Billing Address
                    </span>
                    {orderDetails?.address ? (
                      <span className="font14x500 text-end">
                        <span>{orderDetails?.address?.completeAddress}, </span>
                        {orderDetails?.address?.nearestLandmark !== "" && (
                          <span>
                            {orderDetails?.address?.nearestLandmark},{" "}
                          </span>
                        )}
                        <span>{orderDetails?.address?.city}, </span> <br />
                        <span>{orderDetails?.address?.state}, </span>
                        <span>{orderDetails?.address?.country}, </span>
                        <span>{orderDetails?.address?.pincode}</span>
                      </span>
                    ) : (
                      <span className="font14x500 text-end">
                        {orderDetails?.salon?.address?.line_1},{" "}
                        {orderDetails?.salon?.address?.line_2 &&
                          `${orderDetails?.salon?.address?.line_2}, `}
                        {orderDetails?.salon?.address?.city}, <br />{" "}
                        {orderDetails?.salon?.address?.state},{" "}
                        {orderDetails?.salon?.address?.country},{" "}
                        {orderDetails?.salon?.address?.pincode}
                      </span>
                    )}
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between">
                    <span
                      className="font14x500"
                      style={{ color: "var(--text4)" }}
                    >
                      Shipping Address
                    </span>
                    {orderDetails?.address ? (
                      <span className="font14x500 text-end">
                        <span>{orderDetails?.address?.completeAddress}, </span>
                        {orderDetails?.address?.nearestLandmark !== "" && (
                          <span>
                            {orderDetails?.address?.nearestLandmark},{" "}
                          </span>
                        )}
                        <span>{orderDetails?.address?.city}, </span> <br />
                        <span>{orderDetails?.address?.state}, </span>
                        <span>{orderDetails?.address?.country}, </span>
                        <span>{orderDetails?.address?.pincode}</span>
                      </span>
                    ) : (
                      <span className="font14x500 text-end">
                        {orderDetails?.salon?.address?.line_1},{" "}
                        {orderDetails?.salon?.address?.line_2 &&
                          `${orderDetails?.salon?.address?.line_2}, `}
                        {orderDetails?.salon?.address?.city}, <br />{" "}
                        {orderDetails?.salon?.address?.state},{" "}
                        {orderDetails?.salon?.address?.country},{" "}
                        {orderDetails?.salon?.address?.pincode}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="col-lg-5 col-12 g-lg-4">
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">Location</h3>
              </div>
              <div className="cardContent location-cardcontent  p-0">
                <div
                  style={{
                    position: "relative",
                    height: "300px",
                  }}
                >
                  <RenderMap
                    google={window.google}
                    latitude={
                      orderDetails?.address
                        ? orderDetails?.address?.lat
                        : orderDetails?.salon?.location?.lat
                    }
                    longitude={
                      orderDetails?.address
                        ? orderDetails?.address?.lng
                        : orderDetails?.salon?.location?.lng
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* payment summary */}
          <div
            className="col-lg-5 col-12 g-lg-4"
            style={{ height: "fit-content" }}
          >
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">Payment Summary</h3>
              </div>
              <div className="cardContent">
                {/* <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Payment Method
                  </span>
                  <span className="font14x500">COD</span>
                </div> */}
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Subtotal (inclusive tax):
                  </span>
                  {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                    <span className="font14x500">{`${String.fromCharCode(
                      orderDetails?.salon?.country?.htmlSymbol
                    )} ${
                      orderDetails?.cartCalculations?.products?.total
                    }`}</span>
                  ) : (
                    <span className="font14x500">{`${orderDetails?.salon?.country?.currency} ${orderDetails?.cartCalculations?.products?.total}`}</span>
                  )}
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Discount
                  </span>
                  {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                    <span className="font14x500">{`${String.fromCharCode(
                      orderDetails?.salon?.country?.htmlSymbol
                    )} ${
                      orderDetails?.cartCalculations?.products?.discount
                    }`}</span>
                  ) : (
                    <span className="font14x500">{`${orderDetails?.salon?.country?.currency} ${orderDetails?.cartCalculations?.products?.discount}`}</span>
                  )}
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Coupon Discount
                  </span>
                  {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                    <span className="font14x500">{`${String.fromCharCode(
                      orderDetails?.salon?.country?.htmlSymbol
                    )} ${orderDetails?.cartCalculations?.products?.couponDiscount?.toFixed(
                      2
                    )}`}</span>
                  ) : (
                    <span className="font14x500">{`${
                      orderDetails?.salon?.country?.currency
                    } ${orderDetails?.cartCalculations?.products?.couponDiscount?.toFixed(
                      2
                    )}`}</span>
                  )}
                </div>

                {orderDetails?.cartCalculations?.products?.deliveryCharges >
                  0 && (
                  <div className="d-flex justify-content-between">
                    <span
                      className="font14x500"
                      style={{ color: "var(--text4)" }}
                    >
                      Delivery Charges
                    </span>
                    {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                      <span className="font14x500">{`${String.fromCharCode(
                        orderDetails?.salon?.country?.htmlSymbol
                      )} ${
                        orderDetails?.cartCalculations?.products
                          ?.deliveryCharges
                      }`}</span>
                    ) : (
                      <span className="font14x500">{`${orderDetails?.salon?.country?.currency} ${orderDetails?.cartCalculations?.products?.deliveryCharges}`}</span>
                    )}
                  </div>
                )}
                {role === ADMIN &&
                  orderDetails?.cartCalculations?.products
                    ?.productsMembershipDiscount &&
                  orderDetails?.cartCalculations?.products
                    ?.productsMembershipDiscount > 0 && (
                    <div className="d-flex justify-content-between">
                      <span
                        className="font14x500"
                        style={{ color: "var(--text4)" }}
                      >
                        Membership Discount
                      </span>
                      {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                        <span className="font14x500">{`${String.fromCharCode(
                          orderDetails?.salon?.country?.htmlSymbol
                        )} ${orderDetails?.cartCalculations?.products?.productsMembershipDiscount?.toFixed(
                          2
                        )}`}</span>
                      ) : (
                        <span className="font14x500">{`${
                          orderDetails?.salon?.country?.currency
                        } ${orderDetails?.cartCalculations?.products?.productsMembershipDiscount?.toFixed(
                          2
                        )}`}</span>
                      )}
                    </div>
                  )}
                <hr />
                <div className="d-flex justify-content-between">
                  <span
                    className="font14x500"
                    style={{ color: "var(--text4)" }}
                  >
                    Total Payable Amount
                  </span>
                  {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                    <span className="font14x500">{`${String.fromCharCode(
                      orderDetails?.salon?.country?.htmlSymbol
                    )} ${orderDetails?.cartCalculations?.products?.grandTotal?.toFixed(
                      2
                    )}`}</span>
                  ) : (
                    <span className="font14x500">{`${
                      orderDetails?.salon?.country?.currency
                    } ${orderDetails?.cartCalculations?.products?.grandTotal?.toFixed(
                      2
                    )}`}</span>
                  )}
                </div>
                {role === ADMIN &&
                  orderDetails?.cartCalculations?.products?.commision > 0 && (
                    <div className="d-flex justify-content-between">
                      <span
                        className="font14x500"
                        style={{ color: "var(--text4)" }}
                      >
                        Groome Commision
                      </span>
                      {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                        <span className="font14x500">{`${String.fromCharCode(
                          orderDetails?.salon?.country?.htmlSymbol
                        )} ${orderDetails?.cartCalculations?.products?.commision?.toFixed(
                          2
                        )}`}</span>
                      ) : (
                        <span className="font14x500">{`${
                          orderDetails?.salon?.country?.currency
                        } ${orderDetails?.cartCalculations?.products?.commision?.toFixed(
                          2
                        )}`}</span>
                      )}
                    </div>
                  )}
                {role === ADMIN &&
                  orderDetails?.wallet > 0 &&
                  orderDetails?.qrCode === false && (
                    <div className="d-flex justify-content-between">
                      <span
                        className="font14x500"
                        style={{ color: "var(--text4)" }}
                      >
                        Wallet
                      </span>
                      {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                        <span className="font14x500">{`${String.fromCharCode(
                          orderDetails?.salon?.country?.htmlSymbol
                        )} ${walletBreak(orderDetails?.wallet)}`}</span>
                      ) : (
                        <span className="font14x500">{`${
                          orderDetails?.salon?.country?.currency
                        } ${walletBreak(orderDetails?.wallet)}`}</span>
                      )}
                    </div>
                  )}
              </div>
            </div>
          </div>

          {/* Product Summary */}
          <div className="col-lg-7 col-12 g-lg-4">
            <div className="cardWrapper">
              <div className="cardWrapperHeader">
                <h3 className="font22x500 mb-0">Product Summary</h3>
              </div>
              <div className="cardContent">
                {orderDetails?.productOrders?.products?.map((item, i) => {
                  return (
                    <div
                      className="servicesContainer row gx-0 pb-3 mb-3"
                      key={i}
                    >
                      <div className="col-lg-7 d-flex">
                        {item?.product?.image === null ? (
                          <img
                            src={productImage}
                            alt="service"
                            width={72}
                            height={72}
                            style={{ borderRadius: "4px" }}
                          />
                        ) : (
                          <img
                            src={`${process.env.REACT_APP_Image_BaseURL}${item?.product?.image}`}
                            alt="service"
                            width={72}
                            height={72}
                            style={{ borderRadius: "4px" }}
                          />
                        )}
                        <div className="ps-2 pt-1">
                          <h3 className="mb-0 font14x500">
                            {item?.product?.name}
                          </h3>
                          <p
                            className="mb-0 font12x400"
                            style={{ color: "var(--text4)" }}
                          >
                            {item?.product?.quantity}
                          </p>
                          <p
                            className="mb-0 font12x400 lh-1"
                            style={{ color: "var(--text4)" }}
                          >
                            Quantity: {item?.count}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-5 d-flex justify-content-between align-items-center">
                        <span
                          className="font14x500"
                          style={{ color: "var(--text4)" }}
                        >
                          {`Product Price x ${item?.count}`}
                        </span>
                        <div>
                          <span className="font14x500 me-2">
                            {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                              <s>{`${String.fromCharCode(
                                orderDetails?.salon?.country?.htmlSymbol
                              )} ${item?.product?.mrp * item?.count}`}</s>
                            ) : (
                              <s>{`${orderDetails?.salon?.country?.currency} ${
                                item?.product?.mrp * item?.count
                              }`}</s>
                            )}
                          </span>
                          {orderDetails?.salon?.country?.htmlSymbol !== "" ? (
                            <span>{`${String.fromCharCode(
                              orderDetails?.salon?.country?.htmlSymbol
                            )} ${
                              item?.product?.discountPrice * item?.count
                            }`}</span>
                          ) : (
                            <span>{`${orderDetails?.salon?.country?.currency} ${
                              item?.product?.discountPrice * item?.count
                            }`}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Rating & Review */}
          {orderDetails?.orderReviewAndRating !== null &&
            orderDetails?.orderReviewAndRating?.status !== 0 && (
              <div
                className="col-lg-5 col-12 g-lg-4"
                style={{ height: "fit-content" }}
              >
                <div className="cardWrapper">
                  <div className="cardWrapperHeader">
                    <h3 className="font22x500 mb-0">Rating & Review</h3>
                  </div>
                  <div className="cardContent">
                    <div className="d-flex align-items-center">
                      <p className="font22x700 mb-0 me-3">{`${orderDetails?.orderReviewAndRating?.rating} stars`}</p>
                      <StarRatings
                        rating={orderDetails?.orderReviewAndRating?.rating}
                        starEmptyColor="#a6a6a6"
                        starRatedColor="#FCC153"
                        starDimension="22px"
                        numberOfStars={5}
                        starSpacing="2"
                      />
                    </div>
                    <p className="font14x400 mt-2 lh-sm mb-0">
                      {orderDetails?.orderReviewAndRating?.review}
                    </p>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>

      {commonData.modal && commonData.check === "paymentMode" && (
        <PaymentModeSelection
          state={commonData}
          setState={setCommonData}
          apiCall={apiCall}
        />
      )}
    </>
  );
};

export default Summary;
